import { ActionTypes } from '@/lib/context/actionTypes';
import { UserInterfaceState } from '@/lib/types/userInterfaceState';
import { UserInterfaceActions } from '@/lib/context/userInterfaceActions';

export const UserInterfaceReducer = (state: UserInterfaceState, action: UserInterfaceActions) => {
  switch (action.type) {
    case ActionTypes.UpdateUserInterfaceMenuStatus:
      return { ...state, menuOpen: action.payload.menuOpen };
    case ActionTypes.UpdateUserInterfaceMenuView:
      return { ...state, menuView: action.payload.menuView };
    default:
      return state;
  }
};
